import { z } from "zod";
import { UserPermissionsSchema } from "./User";
import { UserRole } from "@/enums/UserRole";

export const SecurityGroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  permissions: UserPermissionsSchema,
  userRole: z.nativeEnum(UserRole),
});

export const SecurityGroupListSchema = z.array(SecurityGroupSchema);

export type SecurityGroup = z.infer<typeof SecurityGroupSchema>;
